"use strict";

var _react = _interopRequireDefault(require("react"));
var _ = require(".");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var api_host = process.env.MIXPANEL_API_BASE || 'https://api.mixpanel.com';
function isEnable(options) {
  return (process.env.NODE_ENV === "production" || options.enableOnDevMode) && options.apiToken;
}
function trackEvent(eventName, properties) {
  if (eventName) _.mixpanel.track(eventName, properties);
}
function trackPageViews(location, pageViews, trackPageViewsAs, getPageViewTransformerFn) {
  if (pageViews && location) {
    var eventName;
    if (pageViews instanceof Object) {
      eventName = pageViews[location.pathname];
    } else if (trackPageViewsAs) {
      eventName = trackPageViewsAs;
    } else if (pageViews === 'all') {
      eventName = "View page ".concat(location.pathname);
    }
    var pageViewEventTransformerFn = new Function('location', getPageViewTransformerFn);
    var event = pageViewEventTransformerFn()(location);
    trackEvent(eventName, event);
  }
}
function getOptions(pluginOptions) {
  var defaultsOptions = {
    apiToken: null,
    enableOnDevMode: true,
    mixpanelConfig: null,
    trackPageViewsAs: null,
    getPageViewTransformerFn: 'return function(location) { return location; }'
  };
  var options = _objectSpread(_objectSpread({}, defaultsOptions), pluginOptions);
  return _objectSpread(_objectSpread({}, options), {}, {
    isEnable: isEnable(options)
  });
}
exports.onRouteUpdate = function (_ref, pluginOptions) {
  var location = _ref.location;
  var options = getOptions(pluginOptions);
  if (!isEnable(options)) {
    return;
  }
  trackPageViews(location, options.pageViews, options.trackPageViewsAs, options.getPageViewTransformerFn);
};
exports.onClientEntry = function (skip, pluginOptions) {
  var options = getOptions(pluginOptions);
  if (!options.isEnable) {
    _.mixpanel.init('disable', {
      autotrack: false,
      api_host: api_host
    });
    _.mixpanel.disable();
    return;
  }
  var customOptions = _extends({
    track_pageview: false,
    api_host: api_host
  }, options.mixpanelConfig);
  _.mixpanel.init(options.apiToken, customOptions);
};
exports.wrapRootElement = function (_ref2) {
  var element = _ref2.element;
  return /*#__PURE__*/_react["default"].createElement(_.MixpanelProvider, null, element);
};